module.exports = __webpack_public_path__ + "img/bg_pic1.14e74201.png";